import type { $Fetch } from 'ofetch';
import type { FinanceiroDashboard } from '@/domain/model/FinanceiroDashboard';
import type { FinanceiroDashboardGateway } from '@/application/port/out/FinanceiroDashboardGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpFinanceiroDashboardGateway implements FinanceiroDashboardGateway {
  constructor(private readonly client: $Fetch) {}

  async fetch(): Promise<FinanceiroDashboard> {
    const res = await this.client<ApiResponse<FinanceiroDashboard>>('/api/v1/commerce/dashboard', {
      method: 'GET',
    });
    assertApiSuccess(res);
    return res.data;
  }
}
